package dev.terrakok.mapitan.ui.components

import androidx.compose.foundation.border
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.BasicTextField
import androidx.compose.material3.LocalTextStyle
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.unit.dp
import dev.terrakok.mapitan.domain.Label

@Composable
fun LabelTextEditor(
    text: String,
    onTextChanged: (String) -> Unit,
    modifier: Modifier = Modifier,
    updateWhileTyping: Boolean = false,
) {
    var fieldValue by remember {
        mutableStateOf(TextFieldValue(text, TextRange(text.length)))
    }
    var isFocused by remember { mutableStateOf(false) }

    LaunchedEffect(text, isFocused) {
        if (!isFocused && fieldValue.text != text) {
            fieldValue = TextFieldValue(text, TextRange(text.length))
        }
    }

    Column(modifier = modifier) {
        Text(
            text = "Text",
            style = MaterialTheme.typography.titleSmall,
            fontWeight = FontWeight.Medium,
        )
        Spacer(modifier = Modifier.height(4.dp))
        Box(
            modifier = Modifier
                .fillMaxWidth()
                .border(
                    width = 2.dp,
                    color = MaterialTheme.colorScheme.outline,
                    shape = RoundedCornerShape(6.dp),
                )
                .padding(horizontal = 8.dp, vertical = 6.dp),
        ) {
            if (fieldValue.text.isEmpty()) {
                Text(
                    text = Label.DEFAULT_TEXT,
                    style = LocalTextStyle.current,
                    color = MaterialTheme.colorScheme.onSurfaceVariant,
                )
            }
            BasicTextField(
                value = fieldValue,
                onValueChange = { newValue ->
                    fieldValue = newValue.copy(text = Label.limitText(newValue.text))
                    if (updateWhileTyping) onTextChanged(fieldValue.text)
                },
                textStyle = LocalTextStyle.current.copy(color = MaterialTheme.colorScheme.onSurface),
                cursorBrush = SolidColor(MaterialTheme.colorScheme.primary),
                singleLine = false,
                maxLines = Label.MAX_TEXT_LINES,
                modifier = Modifier
                    .fillMaxWidth()
                    .onPreviewKeyEvent { event ->
                        isFocused && event.type == KeyEventType.KeyUp
                    }
                    .onFocusChanged { focusState ->
                        if (isFocused && !focusState.isFocused && fieldValue.text != text) {
                            onTextChanged(fieldValue.text)
                        }
                        isFocused = focusState.isFocused
                    },
            )
        }
        Text(
            modifier = Modifier.padding(top = 4.dp).align(Alignment.End),
            text = "${fieldValue.text.length}/${Label.MAX_TEXT_LENGTH}",
            style = MaterialTheme.typography.labelSmall,
            color = MaterialTheme.colorScheme.onSurfaceVariant,
        )
    }
}
